(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs-layout')) {
    class ProductTabsLayout extends HTMLElement {
      constructor() {
        super();
        this.handleSizeChartClick = this.handleSizeChartClick.bind(this);
        this.handleSizeChartKeydown = this.handleSizeChartKeydown.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleSizeChartClick, true);
        this.addEventListener('keydown', this.handleSizeChartKeydown);
        document.addEventListener('click', this.handleOutsideClick);
        this.prepareExistingSizeChartTriggers();
        this.formatProductDescription();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleSizeChartClick, true);
        this.removeEventListener('keydown', this.handleSizeChartKeydown);
        document.removeEventListener('click', this.handleOutsideClick);
      }

      get popup() {
        return this.querySelector('.popup-content');
      }

      get sizeChartTriggers() {
        return this.querySelectorAll('.popup-button, [data-size-chart-trigger]');
      }

      prepareExistingSizeChartTriggers() {
        const popup = this.popup;

        if (!popup) {
          return;
        }

        this.sizeChartTriggers.forEach((trigger) => {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('tabindex', '0');
          trigger.setAttribute('aria-controls', popup.id);
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      handleSizeChartClick(event) {
        const closeButton = event.target.closest('[data-size-chart-close]');

        if (closeButton && this.contains(closeButton)) {
          event.preventDefault();
          event.stopPropagation();
          this.closeSizeChartPopup();
          return;
        }

        const trigger = event.target.closest('.popup-button, [data-size-chart-trigger]');

        if (!trigger || !this.contains(trigger)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.toggleSizeChartPopup();
      }

      handleSizeChartKeydown(event) {
        if (event.key === 'Escape') {
          this.closeSizeChartPopup();
          return;
        }

        const trigger = event.target.closest('.popup-button, [data-size-chart-trigger]');

        if (!trigger || !this.contains(trigger)) {
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleSizeChartPopup();
        }
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.closeSizeChartPopup();
        }
      }

      toggleSizeChartPopup() {
        const popup = this.popup;

        if (!popup) {
          return;
        }

        const isOpen = popup.classList.toggle('active');
        this.classList.toggle('popup-open', isOpen);
        document.body.classList.toggle('overflow-hidden', isOpen);
        this.sizeChartTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', String(isOpen));
        });
      }

      closeSizeChartPopup() {
        const popup = this.popup;

        if (!popup || !popup.classList.contains('active')) {
          return;
        }

        popup.classList.remove('active');
        this.classList.remove('popup-open');
        document.body.classList.remove('overflow-hidden');
        this.sizeChartTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      addSizeChartTrigger(container) {
        if (!this.popup || container.querySelector('.popup-button, [data-size-chart-trigger]')) {
          return;
        }

        const template = this.querySelector('[data-size-chart-trigger-template]');

        if (!template) {
          return;
        }

        container.prepend(template.content.cloneNode(true));
        this.prepareExistingSizeChartTriggers();
      }

      formatDescriptionTables(tables) {
        tables.forEach((table) => {
          let volumeRow = null;

          Array.from(table.rows).forEach((row) => {
            const labels = Array.from(row.cells).map((cell) =>
              cell.textContent.trim().toLowerCase().replace(/[:\s]+$/g, '')
            );
            const firstLabel = labels[0] || '';

            if (firstLabel === 'merkmal' || firstLabel === 'mermal') {
              row.remove();
              return;
            }

            if (firstLabel === 'durchmesser') {
              row.classList.add('product-description-table__diameter-row');
            }

            if (firstLabel === 'volumen') {
              volumeRow = row;
            }
          });

          if (volumeRow) {
            const rowGroup = volumeRow.parentElement;
            const firstRow = Array.from(rowGroup.children).find((child) => child.tagName === 'TR');

            if (firstRow && firstRow !== volumeRow) {
              rowGroup.insertBefore(volumeRow, firstRow);
            }
          }
        });
      }

      formatProductDescription() {
        const description = this.querySelector('[data-product-description]');

        if (!description || description.dataset.tableLayoutReady === 'true') {
          return;
        }

        const tables = Array.from(description.querySelectorAll('table'));
        this.formatDescriptionTables(tables);

        const existingLayout = description.querySelector('.discription-wrapper-main');
        const existingContent = existingLayout?.querySelector('.discription-wrapper-inner');
        const existingTable = existingLayout?.querySelector('.table-wrapper');

        if (existingLayout && existingContent && existingTable) {
          existingLayout.classList.add('product-description-layout');
          existingContent.classList.add('product-description-layout__content');
          existingTable.classList.add('product-description-layout__table');
          this.addSizeChartTrigger(existingTable);
          description.dataset.tableLayoutReady = 'true';
          return;
        }

        if (tables.length === 0) {
          description.dataset.tableLayoutReady = 'true';
          return;
        }

        const layout = document.createElement('div');
        const contentColumn = document.createElement('div');
        const tableColumn = document.createElement('div');
        const movedContainers = new Set();

        layout.className = 'product-tabs__generated-layout';
        contentColumn.className = 'product-description-layout__content';
        tableColumn.className = 'product-description-layout__table';

        while (description.firstChild) {
          contentColumn.appendChild(description.firstChild);
        }

        tables.forEach((table) => {
          const tableWrapper = table.closest('.table-wrapper');

          if (tableWrapper && !movedContainers.has(tableWrapper)) {
            tableColumn.appendChild(tableWrapper);
            movedContainers.add(tableWrapper);
            return;
          }

          if (tableWrapper) {
            return;
          }

          const tableContainer = document.createElement('div');
          tableContainer.className = 'product-description-table';
          tableContainer.appendChild(table);
          tableColumn.appendChild(tableContainer);
        });

        this.addSizeChartTrigger(tableColumn);
        layout.append(contentColumn, tableColumn);
        description.appendChild(layout);
        description.dataset.tableLayoutReady = 'true';
      }
    }

    customElements.define('product-tabs-layout', ProductTabsLayout);
  }

  } catch(e) { console.error(e); }
})();
})();
